import { styled } from 'linaria/react';
import { css } from 'linaria';
import { sectionMarginHeight } from 'common/components/page-section';

export namespace Containers {
  export const ComplementMovementBlocks = styled.div`
    display: flex;
    flex-direction: column;
    transition: all 300ms ease-in-out;
    @media (--to-tablet) {
      width: 100vw !important;
      margin: 0 -16px;
      #collectionProducts > div {
        padding-right: var(--space-200);
        padding-left: var(--space-200);
      }
    }
  `;
}

export namespace Styles {
  export const title = css`
    @media (--only-mobile) {
      margin: 0 var(--space-200);
    }
  `;

  export const pdpD9nSectionContainer = css`
    width: 100%;
    p {
      overflow: hidden;
    }
    margin-top: var(--space-550);

    @media (--only-mobile) {
      margin-top: var(--space-300);
    }
  `;

  export const pdpSectionInsideInfoBlockStyle = css`
    width: inherit;
    margin-left: 0;
    margin-right: 0;

    p {
      width: 100% !important;
      margin: 0;
    }
  `;

  export const pdpReviewsFormContentWrapper = css`
    /* fixed used for correct scroll positioning when switching from/to reviews form */
    position: fixed;
    width: 100%;
    height: var(--screen-available-height);
    overflow: auto;
  `;
}

export const orderedContentNotSellable = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  #suggested {
    order: 1;
  }
  #substitutes {
    order: 2;
  }
  #collectionProducts {
    order: 3;
  }
  #complements {
    order: 4;
  }
  #reviews {
    order: 6;
  }
  #collectionProducts,
  #complements,
  #substitutes {
    @media (--from-tablet) {
      margin-top: calc(${sectionMarginHeight}px / 2);
      &::before {
        display: none;
      }
      &::after {
        content: '';
        display: block;
        width: 100%;
        margin: calc(${sectionMarginHeight}px / 2) 0 0;
        border-top: 1px solid var(--control-minor);
      }
    }
  }
  #description-container {
    order: 4;
  }
`;

export const productInformationContainer = css`
  display: flex;
  width: 100%;
  gap: 64px;
  margin-top: var(--space-300);

  @media (--only-desktop) {
    gap: 40px;
    padding-bottom: var(--space-500);
  }
`;

export const productInfoDesktopPlusStyle = css`
  margin-top: var(--space-200);
  flex-basis: 422px !important;
  max-width: 422px !important;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (--only-desktop) {
    flex-basis: 322px !important;
    max-width: 322px !important;
  }
`;

export const pageContent = css`
  display: block;
  width: 694px;

  @media (--only-desktop) {
    width: 578px;
  }

  @media (--to-desktop) {
    width: 660px;
  }

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const paddingReset = css`
  padding: 0;
`;

export const descriptionContent = css`
  width: 100%;
`;

export const ssrRemote = css`
  display: none;
`;

export const navigation = css`
  @media (--only-tablet) {
    margin-top: var(--space-500);
  }
`;

export const sectionDivider = css`
  @media (--from-tablet) {
    &::before {
      content: '';
      display: block;
      width: 100%;
      margin: calc(${sectionMarginHeight}px / 2) 0;
      border-top: 1px solid var(--control-minor);
    }

    margin-top: 0;
  }
`;
